import { render } from "./DdtModal.vue?vue&type=template&id=1fc47848&scoped=true"
import script from "./DdtModal.vue?vue&type=script&lang=js"
export * from "./DdtModal.vue?vue&type=script&lang=js"

import "./DdtModal.vue?vue&type=style&index=0&id=1fc47848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc47848"]])

export default __exports__